


import DashboardEn from "./Injaz-DashboardEn.jsx";
import DashboardAr from "./Injaz-DashboardAr.jsx";
import { connect } from 'react-redux';
let Dashboard='';
const mapStateToProps = ({user}) => ({
	user
});
if(localStorage.getItem('lang')==='EN'){
	//export default connect(mapStateToProps)(DashboardEn);
	Dashboard=DashboardEn;
}	
else{
	Dashboard=DashboardAr;
}

export default connect(mapStateToProps)(Dashboard);
// const mapStateToProps = state => {
// 	// return {
// 	//   objects: state.objectIds.map(id => state.objects[id])
// 	// }
// 	return state;
//   }

// const mapDispatchToProps = dispatch => ({
//     loginThunk: (usernameOrEmail, password) => dispatch(loginThunk(usernameOrEmail, password))
//     // ,
// 	// tokenAuthThunk: () => dispatch(tokenAuthThunk()),
// });

// if(localStorage.getItem('lang')=='EN'){
// 	export default connect(mapStateToProps)(DashboardEn);
// }
// else{
// 	export default connect(mapStateToProps)(DashboardAr);
// }

